import React,{useState,useEffect} from "react";
import "flatpickr/dist/themes/dark.css";
import Flatpickr from "react-flatpickr";

const DateRange = ({name,value,onChange}) => {

    const changeDate = (date) => {
        if (onChange && name && date?.length === 2) {
            onChange(name,date)
        }
    }

    return <>
        <Flatpickr
        className="form-control"
        options={{
            mode: "range",
            dateFormat: "M j, Y",
            maxDate: "today"
        }}
        placeholder="Date range"
        value={value}
        onChange={changeDate}
    />
        </>
}

export default DateRange
